(function () {
  function getColorFilter() {
    const params = new URLSearchParams(window.location.search);

    return (
      params.get('filter.v.option.color') ||
      params.get('filter.p.m.custom.color')
    );
  }

  function isColorFiltered() {
    return !!getColorFilter();
  }

  window.ColorFilterState = {
    isActive: isColorFiltered(),
    value: getColorFilter()
  };
})();